document.addEventListener("DOMContentLoaded", () => {

  const BUNDLE_SELECTOR =
    '#rbr-container-element-true';

  let initialized = false;

  const waitForBundle = setInterval(() => {

    const bundleWrapper =
      document.querySelector(
        BUNDLE_SELECTOR
      );

    if (bundleWrapper && !initialized) {
      clearInterval(waitForBundle);
      initBundle(bundleWrapper);

    }

  }, 300);

  function initBundle(bundleWrapper) {

    initialized = true;

    const nativeATC =
      document.querySelector(
        '.buy-buttons .button.w-full[type="submit"]'
      );

    const customButton =
      document.querySelector(
        '.custom-build-bundle-btn'
      );

    if (
      !nativeATC ||
      !customButton
    ) return;


    let userStartedBuilding = false;

    customButton.style.display =
      'flex';

    nativeATC.style.display =
      'none';


    function getAccordionHeads() {

      return [
        ...bundleWrapper.querySelectorAll(
          '[class*="Accordion_head"]'
        )
      ];

    }


    function getPanel(head) {

      return head.nextElementSibling;

    }
    function isClosed(panel) {

      if (!panel) return false;

      return (
        !panel.style.maxHeight ||
        panel.style.maxHeight === '0px'
      );

    }

    function openAccordion(head) {

      if (!head) return;

      const panel =
        getPanel(head);

      if (!panel) return;

      if (isClosed(panel)) {

        head.click();

      }
      setTimeout(() => {

        head.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

      }, 250);

    }
    function getNextIncompleteAccordion() {

      const heads =
        getAccordionHeads();

      for (const head of heads) {

        const wrapper =
          head.closest(
            '[class*="MainSection_divider"]'
          );

        if (!wrapper) continue;
        const addedText =
          wrapper.querySelector(
            '[class*="style_numberText"]'
          );

        const requiredText =
          wrapper.querySelector(
            '[class*="style_endLabel"]'
          );

        if (requiredText) {

          const currentCount =
            parseInt(
              addedText?.textContent || '0'
            );

          const requiredCount =
            parseInt(
              requiredText?.textContent || '0'
            );

          if (currentCount < requiredCount) {

            return head;
          }

        }
        else {

          const hasSelectedProduct =
            wrapper.querySelector(
              '[class*="SelectedVariantsList_item"]'
            );

          if (!hasSelectedProduct) {

            return head;
          }

        }
      }
      return null;

    }

    function updateButtons() {
      if (!userStartedBuilding) {

        customButton.style.display =
          'flex';

        nativeATC.style.display =
          'none';

        return;

      }
      const nextIncompleteAccordion =
        getNextIncompleteAccordion();

      const bundleComplete =
        !nextIncompleteAccordion;

      if (bundleComplete) {

        customButton.style.display =
          'none';

        nativeATC.style.display =
          '';
      }

      else {
        customButton.style.display =
          'flex';
        nativeATC.style.display =
          'none';
      }
    }
    setTimeout(() => {
      const first =
        getNextIncompleteAccordion();
      if (first) {
        openAccordion(first);
      }

    }, 1000);

    customButton.addEventListener(
      'click',
      (e) => {

        e.preventDefault();

        const nextAccordion =
          getNextIncompleteAccordion();

        if (nextAccordion) {

          openAccordion(nextAccordion);

        }

      }
    );

    bundleWrapper.addEventListener(
      'click',
      (e) => {

        const addButton =
          e.target.closest(
            '[class*="variantSelector_container"]'
          );

        if (!addButton) return;

        userStartedBuilding = true;

        setTimeout(() => {

          const nextAccordion =
            getNextIncompleteAccordion();

          if (nextAccordion) {

            const currentWrapper =
              addButton.closest(
                '[class*="MainSection_divider"]'
              );

            const currentHead =
              currentWrapper?.querySelector(
                '[class*="Accordion_head"]'
              );

            if (
              currentHead &&
              nextAccordion !== currentHead
            ) {

              openAccordion(nextAccordion);

            }

          }

          updateButtons();

        }, 400);

      }
    );

const observer =
  new MutationObserver(() => {

    requestAnimationFrame(() => {
      updateButtons();
    });

  });

observer.observe(bundleWrapper, {
  childList: true,
  subtree: true
});
    updateButtons();

  }

});
/*
=========================================================
Button Loader
=========================================================
*/
setTimeout(() => {

  const loaderWrapper =
    document.querySelector(
      '.bundle-loader-wrapper'
    );

  if (loaderWrapper) {

    loaderWrapper.classList.remove(
      'loading'
    );

  }

}, 1200);